// Shared helpers for lead submissions.
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function readAttribution(searchParams) {
  const attribution = {};
  const p = searchParams.get("product");
  const s = searchParams.get("solution");
  const i = searchParams.get("industry");
  const r = searchParams.get("resource");
  if (p) attribution.product_slug = p;
  if (s) attribution.solution_slug = s;
  if (i) attribution.industry = i;
  if (r) attribution.resource = r;
  if (typeof document !== "undefined" && document.referrer) {
    attribution.referrer = document.referrer.slice(0, 512);
  }
  return attribution;
}

export function baseMeta({ consent_ack = false } = {}) {
  return {
    user_agent: typeof navigator !== "undefined" ? navigator.userAgent : "",
    submitted_at_client: new Date().toISOString(),
    consent_ack,
  };
}

export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const res = await fetch(`${API}/uploads`, {
    method: "POST",
    body: fd,
  });
  const contentType = res.headers.get("content-type") || "";
  const data = contentType.includes("application/json") ? await res.json() : null;
  if (res.status === 201) return { ok: true, data };
  return {
    ok: false,
    status: res.status,
    error: (data && (data.detail || data.error)) || `Upload failed (${res.status})`,
  };
}

export async function submitLead(body) {
  const res = await fetch(`${API}/leads`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const contentType = res.headers.get("content-type") || "";
  const data = contentType.includes("application/json") ? await res.json() : null;
  if (res.status === 201 || res.status === 200) {
    return { ok: true, status: res.status, data };
  }
  if (res.status === 422) {
    return { ok: false, status: 422, error: "validation", detail: data?.detail };
  }
  if (res.status === 429) {
    return { ok: false, status: 429, error: "rate_limited", retryAfter: res.headers.get("Retry-After") };
  }
  return { ok: false, status: res.status, error: "server", detail: data };
}
